

export const config = {
    apiEndpoint: "https://api.thesellerapp.com/public/index.php/api",
    awsKeyId:"AKIAYJUL5VJOBYQMJDT7",
    awsSecretKey:"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"
}